import React from 'react';
import { services } from '../data/services';
import { contact, images, urls } from '../data/site';
import { linkTargetProps } from '../utils/links';
const companyLinks = [{
  label: 'Our Work Gallery',
  href: urls.gallery
}, {
  label: 'Request a Quote',
  href: urls.quote
}, {
  label: 'Contact Page',
  href: urls.contact
}, {
  label: 'Trailer Body Repair',
  href: urls.trailer
}, {
  label: 'Make a Payment',
  href: urls.payment
}, {
  label: 'Careers',
  href: urls.careers
}, {
  label: 'Heavy Equipment Restoration',
  href: urls.heavyEquipment
}];
const linkClass = 'inline-flex min-h-[36px] items-center text-[15px] text-steel-light transition-colors duration-150 ease-out hover:text-paper';
export function SiteFooter() {
  return <footer className="bg-ink text-paper" data-id="element-270" data-mp="2ylewelleac7p">
      <div className="mx-auto grid max-w-[1320px] gap-12 px-5 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-12 lg:px-12 lg:py-20" data-id="element-271" data-mp="11r1yc9o3pb3t">
        <div className="lg:col-span-4" data-id="element-272" data-mp="wta8rmaxi12s">
          <span className="inline-block bg-paper px-4 py-3" data-id="element-273" data-mp="wq4l8bhy7796">
            <img src={images.logo} alt="Motor City Truck Collision" className="h-10 w-auto max-w-[200px] object-contain" data-id="element-274" data-mp="15q2a0ncfp28o" />
          </span>
          <p className="mt-6 max-w-[22rem] text-[15px] leading-relaxed text-steel-light" data-id="element-275" data-mp="1anlnvm57zd03">
            Commercial truck collision repair, bodywork and painting in Brighton, Michigan.
          </p>
          <a href={contact.phoneHref} className="mt-6 inline-block font-display text-[28px] font-bold tracking-[0.02em] text-paper hover:text-brand-bright" data-id="element-276" data-mp="10tv58xvrxwsb">
            {contact.phoneDisplay}
          </a>
          <address className="mt-2 text-[15px] not-italic leading-relaxed text-steel-light" data-id="element-277" data-mp="1esbk5c3sitlj">
            {contact.street}
            <br data-id="element-278" data-mp="1jpbp1jowlqb2" />
            {contact.cityLine}
          </address>
        </div>

        <nav aria-label="Services" className="lg:col-span-3" data-id="element-279" data-mp="27fyxq76n8jyo">
          <h2 className="text-[12px] font-semibold uppercase tracking-[0.16em] text-brand-bright" data-id="element-280" data-mp="2c6xibiyo047q">Services</h2>
          <ul className="mt-4" data-id="element-281" data-mp="2m2nz6ekgh77p">
            {services.map(s => <li key={s.title} data-id="element-282" data-mp="2m0tmfnjc8lep">
                <a href={s.href} {...linkTargetProps(s.href)} className={linkClass} data-id="element-283" data-mp="2h42zcg948pjs">
                  {s.title}
                </a>
              </li>)}
          </ul>
        </nav>

        <nav aria-label="Company" className="lg:col-span-2" data-id="element-284" data-mp="283et47pyrthg">
          <h2 className="text-[12px] font-semibold uppercase tracking-[0.16em] text-brand-bright" data-id="element-285" data-mp="282vdixnsdh6l">Company</h2>
          <ul className="mt-4" data-id="element-286" data-mp="2364wo845qhk4">
            {companyLinks.map(l => <li key={l.label} data-id="element-287" data-mp="1ybsb9sj4ew5q">
                <a href={l.href} {...linkTargetProps(l.href)} className={linkClass} data-id="element-288" data-mp="1ybihruyva6va">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="lg:col-span-3" data-id="element-289" data-mp="1pau3r09h46ie">
          <h2 className="text-[12px] font-semibold uppercase tracking-[0.16em] text-brand-bright" data-id="element-290" data-mp="1kdtxao8pp1qr">Our family</h2>
          <img src={images.garrettLogo} alt="Garrett Auto & Truck Service" loading="lazy" className="mt-5 h-12 w-auto max-w-[200px] object-contain" data-id="element-291" data-mp="1ffip0hy2ezan" />
          <p className="mt-5 text-[15px] leading-relaxed text-steel-light" data-id="element-292" data-mp="3vzmalvs2ygpc">
            Part of the Garrett Auto &amp; Truck Service family. Garrett has served Southeast Michigan since 1958.
          </p>
          <a href={urls.garrett} {...linkTargetProps(urls.garrett)} className={`${linkClass} mt-2 text-paper underline decoration-brand underline-offset-4`} data-id="element-293" data-mp="8vobse2lyvq1">
            garrettauto.com
          </a>
        </div>
      </div>

      <div className="border-t border-ink-line" data-id="element-294" data-mp="3d8blnk5x0e03">
        <div className="mx-auto flex max-w-[1320px] flex-col gap-2 px-5 py-6 text-[13px] text-steel-light sm:flex-row sm:justify-between sm:px-8 lg:px-12" data-id="element-295" data-mp="3hbrm6rl3uyi2">
          <p data-id="element-296" data-mp="3m4kqxfgkq6u5">© 2026 Motor City Truck Collision. All rights reserved.</p>
          <p data-id="element-297" data-mp="2pklenq321yir">Brighton, MI · Serving Southeast Michigan</p>
        </div>
      </div>
    </footer>;
}